import productsMockData from './useProductsMock.json';
import productsSpecialOfferMockData from './useProductsMock.specialOffer.json';

function useProductsMock(mockType) {
  if (mockType === 'specialOffer') {
    return {
      loading: false,
      error: false,
      products: productsSpecialOfferMockData,
    };
  }

  return { loading: false, error: false, products: productsMockData };
}

export default useProductsMock;
